<template>
  <div style="background-color: #edeff3;">
    <!-- ============= 顶部背景图 ============= -->
    <div>
      <img src="../../assets/images/about/recruitbanner.png" style="width: 100%;display: block">
    </div>
    <div class="recruit" id="recruit">
      <div class="recruit-div-left">
        <table class="recruit-table" cellspacing="0">
          <tr>
            <td class="recruitTableTb" :class="{tdBackground:activeName==='announcement'}" name="announcement" @click="recruitTabs('announcement')">社会招聘公告</td>
          </tr>
          <tr>
            <td class="recruitTableTb" :class="{tdBackground:activeName==='register'}" name="register" @click="recruitTabs('register')">注册</td>
          </tr>
          <tr>
            <td class="recruitTableTb" :class="{tdBackground:activeName==='login'}" name="login" @click="recruitTabs('login')">登录</td>
          </tr>
          <tr>
            <td class="recruitTableTb" :class="{tdBackground:activeName==='jobList'}" name="jobList" @click="recruitTabs('jobList')">职位列表</td>
          </tr>
          <tr>
            <td class="recruitTableTb" :class="{tdBackground:activeName==='process'}" name="process" @click="recruitTabs('process')">应聘流程</td>
          </tr>
          <tr>
            <td class="recruitTableTb" :class="{tdBackground:activeName==='InformationPlatform'}" name="InformationPlatform" @click="recruitTabs('InformationPlatform')">资讯台</td>
          </tr>
        </table>
      </div>
            <div class="recruit-div-right" v-if="activeName==='announcement'">
              <div class="recruit-div">
                <p style="font-weight: 600;height: 28px;">社会招聘公告</p>
              </div>
              <!--    分割线   -->
              <!--              <div class="recruit-border">-->

              <!--              </div>-->
              <div class="recruit-div">
                <p class="recruit-div-p">中颖电子股份有限公司成立于1994年7月，多年来致力于消费类电子芯片的研发与生产，是最早在上海成立Design House的企业之一，首批被中国工业及信息化部及上海市信息化办公室认定为集成电路设计企业，并连续十一年被评定为上海市高新技术企业。<br/>
                  中颖电子股份有限公司现注册资金九千六百万人民币，集团营收达到人民币三亿七千万元。<br/>
                  目前我公司的产品线主要是消费类电子芯片的设计生产，涉及的领域有：家用电器和工业控制类单片机、数字信号处理器、电脑周边芯片、锂电池管理与保护芯片等。中颖电子在嵌入式MCU及DSP方面具有较强的技术优势， 目前的嵌入式MCU采用8 英寸0.13-0.5µm CMOS 工艺， 程序存储器采用的是一次可编程ROM（OTP ROM） 或flash， 公司在数模混合电路设计、电磁兼容及产品的可靠性等方面的设计技术处于业界领先水平，在微波炉、电磁炉和电动自行车控制芯片等多项应用领域取得了全球市占率第一的成绩。<br/>
                  中颖电子已在西安成立全资子公司-西安中颖电子有限公司。<br/>
                  依我公司目前规模及产品结构，公司3~5年发展规划如下： <br/>
                  1. MCU产品： <br/>
                  适用于大小家电及智能电表的微控制器芯片研发；变频电机、电源管理等工业控制SOC芯片的研发。<br/>
                  2. 数码音频和存储控制产品: <br/>
                  全功能数码音频SOC芯片； <br/>
                  适用于业界最先进工艺Flash的存储卡控制SOC。<br/>
                  3. 锂电池管理与保护产品线: <br/>
                  设计单串、多串锂电池的容量管理及保护IC。<br/>
                  提供平板电脑、笔记本、电动工具、电动自行车等多种管理及保护方案。 <br/>
                  具体招聘职位及要求，请详见职位列表。</p>
              </div>
            </div>

            <div class="recruit-div-right" v-if="activeName==='register'">
              <div class="recruit-div">
                <p style="font-weight: 600;height: 28px;">注册</p>
              </div>
              <!--    分割线   -->
<!--              <div class="recruit-border">-->

<!--              </div>-->
              <div class="recruit-div">
                <p class="recruit-div-p">中颖电子股份有限公司成立于1994年7月，多年来致力于消费类电子芯片的研发与生产，是最早在上海成立Design House的企业之一，首批被中国工业及信息化部及上海市信息化办公室认定为集成电路设计企业，并连续十一年被评定为上海市高新技术企业。<br/>
                  中颖电子股份有限公司现注册资金九千六百万人民币，集团营收达到人民币三亿七千万元。<br/>
                  目前我公司的产品线主要是消费类电子芯片的设计生产，涉及的领域有：家用电器和工业控制类单片机、数字信号处理器、电脑周边芯片、锂电池管理与保护芯片等。中颖电子在嵌入式MCU及DSP方面具有较强的技术优势， 目前的嵌入式MCU采用8 英寸0.13-0.5µm CMOS 工艺， 程序存储器采用的是一次可编程ROM（OTP ROM） 或flash， 公司在数模混合电路设计、电磁兼容及产品的可靠性等方面的设计技术处于业界领先水平，在微波炉、电磁炉和电动自行车控制芯片等多项应用领域取得了全球市占率第一的成绩。<br/>
                  中颖电子已在西安成立全资子公司-西安中颖电子有限公司。<br/>
                  依我公司目前规模及产品结构，公司3~5年发展规划如下： <br/>
                  1. MCU产品： <br/>
                  适用于大小家电及智能电表的微控制器芯片研发；变频电机、电源管理等工业控制SOC芯片的研发。<br/>
                  2. 数码音频和存储控制产品: <br/>
                  全功能数码音频SOC芯片； <br/>
                  适用于业界最先进工艺Flash的存储卡控制SOC。<br/>
                  3. 锂电池管理与保护产品线: <br/>
                  设计单串、多串锂电池的容量管理及保护IC。<br/>
                  提供平板电脑、笔记本、电动工具、电动自行车等多种管理及保护方案。 <br/>
                  具体招聘职位及要求，请详见职位列表。</p>
              </div>
            </div>

            <div class="recruit-div-right" v-if="activeName==='login'">
              <div class="recruit-div">
                <p style="font-weight: 600;height: 28px;">登录</p>
              </div>
              <!--    分割线   -->
              <!--              <div class="recruit-border">-->

              <!--              </div>-->
              <div class="recruit-div">
                <p class="recruit-div-p">中颖电子股份有限公司成立于1994年7月，多年来致力于消费类电子芯片的研发与生产，是最早在上海成立Design House的企业之一，首批被中国工业及信息化部及上海市信息化办公室认定为集成电路设计企业，并连续十一年被评定为上海市高新技术企业。<br/>
                  中颖电子股份有限公司现注册资金九千六百万人民币，集团营收达到人民币三亿七千万元。<br/>
                  目前我公司的产品线主要是消费类电子芯片的设计生产，涉及的领域有：家用电器和工业控制类单片机、数字信号处理器、电脑周边芯片、锂电池管理与保护芯片等。中颖电子在嵌入式MCU及DSP方面具有较强的技术优势， 目前的嵌入式MCU采用8 英寸0.13-0.5µm CMOS 工艺， 程序存储器采用的是一次可编程ROM（OTP ROM） 或flash， 公司在数模混合电路设计、电磁兼容及产品的可靠性等方面的设计技术处于业界领先水平，在微波炉、电磁炉和电动自行车控制芯片等多项应用领域取得了全球市占率第一的成绩。<br/>
                  中颖电子已在西安成立全资子公司-西安中颖电子有限公司。<br/>
                  依我公司目前规模及产品结构，公司3~5年发展规划如下： <br/>
                  1. MCU产品： <br/>
                  适用于大小家电及智能电表的微控制器芯片研发；变频电机、电源管理等工业控制SOC芯片的研发。<br/>
                  2. 数码音频和存储控制产品: <br/>
                  全功能数码音频SOC芯片； <br/>
                  适用于业界最先进工艺Flash的存储卡控制SOC。<br/>
                  3. 锂电池管理与保护产品线: <br/>
                  设计单串、多串锂电池的容量管理及保护IC。<br/>
                  提供平板电脑、笔记本、电动工具、电动自行车等多种管理及保护方案。 <br/>
                  具体招聘职位及要求，请详见职位列表。</p>
              </div>
            </div>

            <div class="recruit-div-right" v-if="activeName==='jobList'">
              <div class="recruit-div">
                <p style="font-weight: 600;height: 28px;">职位列表</p>
              </div>
              <!--    分割线   -->
              <!--              <div class="recruit-border">-->

              <!--              </div>-->
              <div class="recruit-div">
                <p class="recruit-div-p">中颖电子股份有限公司成立于1994年7月，多年来致力于消费类电子芯片的研发与生产，是最早在上海成立Design House的企业之一，首批被中国工业及信息化部及上海市信息化办公室认定为集成电路设计企业，并连续十一年被评定为上海市高新技术企业。<br/>
                  中颖电子股份有限公司现注册资金九千六百万人民币，集团营收达到人民币三亿七千万元。<br/>
                  目前我公司的产品线主要是消费类电子芯片的设计生产，涉及的领域有：家用电器和工业控制类单片机、数字信号处理器、电脑周边芯片、锂电池管理与保护芯片等。中颖电子在嵌入式MCU及DSP方面具有较强的技术优势， 目前的嵌入式MCU采用8 英寸0.13-0.5µm CMOS 工艺， 程序存储器采用的是一次可编程ROM（OTP ROM） 或flash， 公司在数模混合电路设计、电磁兼容及产品的可靠性等方面的设计技术处于业界领先水平，在微波炉、电磁炉和电动自行车控制芯片等多项应用领域取得了全球市占率第一的成绩。<br/>
                  中颖电子已在西安成立全资子公司-西安中颖电子有限公司。<br/>
                  依我公司目前规模及产品结构，公司3~5年发展规划如下： <br/>
                  1. MCU产品： <br/>
                  适用于大小家电及智能电表的微控制器芯片研发；变频电机、电源管理等工业控制SOC芯片的研发。<br/>
                  2. 数码音频和存储控制产品: <br/>
                  全功能数码音频SOC芯片； <br/>
                  适用于业界最先进工艺Flash的存储卡控制SOC。<br/>
                  3. 锂电池管理与保护产品线: <br/>
                  设计单串、多串锂电池的容量管理及保护IC。<br/>
                  提供平板电脑、笔记本、电动工具、电动自行车等多种管理及保护方案。 <br/>
                  具体招聘职位及要求，请详见职位列表。</p>
              </div>
            </div>

            <div class="recruit-div-right" v-if="activeName==='process'">
              <div class="recruit-div">
                <p style="font-weight: 600;height: 28px;">应聘流程</p>
              </div>
              <!--    分割线   -->
              <!--              <div class="recruit-border">-->

              <!--              </div>-->
              <div class="recruit-div">
                <p class="recruit-div-p">中颖电子股份有限公司成立于1994年7月，多年来致力于消费类电子芯片的研发与生产，是最早在上海成立Design House的企业之一，首批被中国工业及信息化部及上海市信息化办公室认定为集成电路设计企业，并连续十一年被评定为上海市高新技术企业。<br/>
                  中颖电子股份有限公司现注册资金九千六百万人民币，集团营收达到人民币三亿七千万元。<br/>
                  目前我公司的产品线主要是消费类电子芯片的设计生产，涉及的领域有：家用电器和工业控制类单片机、数字信号处理器、电脑周边芯片、锂电池管理与保护芯片等。中颖电子在嵌入式MCU及DSP方面具有较强的技术优势， 目前的嵌入式MCU采用8 英寸0.13-0.5µm CMOS 工艺， 程序存储器采用的是一次可编程ROM（OTP ROM） 或flash， 公司在数模混合电路设计、电磁兼容及产品的可靠性等方面的设计技术处于业界领先水平，在微波炉、电磁炉和电动自行车控制芯片等多项应用领域取得了全球市占率第一的成绩。<br/>
                  中颖电子已在西安成立全资子公司-西安中颖电子有限公司。<br/>
                  依我公司目前规模及产品结构，公司3~5年发展规划如下： <br/>
                  1. MCU产品： <br/>
                  适用于大小家电及智能电表的微控制器芯片研发；变频电机、电源管理等工业控制SOC芯片的研发。<br/>
                  2. 数码音频和存储控制产品: <br/>
                  全功能数码音频SOC芯片； <br/>
                  适用于业界最先进工艺Flash的存储卡控制SOC。<br/>
                  3. 锂电池管理与保护产品线: <br/>
                  设计单串、多串锂电池的容量管理及保护IC。<br/>
                  提供平板电脑、笔记本、电动工具、电动自行车等多种管理及保护方案。 <br/>
                  具体招聘职位及要求，请详见职位列表。</p>
              </div>
            </div>

            <div class="recruit-div-right" v-if="activeName==='InformationPlatform'">
              <div class="recruit-div">
                <p style="font-weight: 600;height: 28px;">资讯台</p>
              </div>
              <!--    分割线   -->
              <!--              <div class="recruit-border">-->

              <!--              </div>-->
              <div class="recruit-div">
                <p class="recruit-div-p">中颖电子股份有限公司成立于1994年7月，多年来致力于消费类电子芯片的研发与生产，是最早在上海成立Design House的企业之一，首批被中国工业及信息化部及上海市信息化办公室认定为集成电路设计企业，并连续十一年被评定为上海市高新技术企业。<br/>
                  中颖电子股份有限公司现注册资金九千六百万人民币，集团营收达到人民币三亿七千万元。<br/>
                  目前我公司的产品线主要是消费类电子芯片的设计生产，涉及的领域有：家用电器和工业控制类单片机、数字信号处理器、电脑周边芯片、锂电池管理与保护芯片等。中颖电子在嵌入式MCU及DSP方面具有较强的技术优势， 目前的嵌入式MCU采用8 英寸0.13-0.5µm CMOS 工艺， 程序存储器采用的是一次可编程ROM（OTP ROM） 或flash， 公司在数模混合电路设计、电磁兼容及产品的可靠性等方面的设计技术处于业界领先水平，在微波炉、电磁炉和电动自行车控制芯片等多项应用领域取得了全球市占率第一的成绩。<br/>
                  中颖电子已在西安成立全资子公司-西安中颖电子有限公司。<br/>
                  依我公司目前规模及产品结构，公司3~5年发展规划如下： <br/>
                  1. MCU产品： <br/>
                  适用于大小家电及智能电表的微控制器芯片研发；变频电机、电源管理等工业控制SOC芯片的研发。<br/>
                  2. 数码音频和存储控制产品: <br/>
                  全功能数码音频SOC芯片； <br/>
                  适用于业界最先进工艺Flash的存储卡控制SOC。<br/>
                  3. 锂电池管理与保护产品线: <br/>
                  设计单串、多串锂电池的容量管理及保护IC。<br/>
                  提供平板电脑、笔记本、电动工具、电动自行车等多种管理及保护方案。 <br/>
                  具体招聘职位及要求，请详见职位列表。</p>
              </div>
            </div>
      <div style="clear:both"></div>

    </div>
  </div>
</template>

<script>
    export default {
        name: "demo3",
        data() {
            return {
                activeName: 'announcement'
            }
        },
        methods: {
            recruitTabs (tabName) {
                this.activeName = tabName
            },
            handleClick(tab, event) {
                console.log(tab, event);
            }
        }
    }

</script>
<style >
.recruit{  margin: 0 auto;  width: 75%;background-color: #fff;}
.recruit-div{line-height: 40px;height: auto;overflow:hidden;}
.recruit-div-left{float: left;line-height: 40px;height: 100%;width: 180px;margin: 0;}
.recruit-div-right{float: left;width: calc(100% - 400px);margin-left: -14px;padding-left: 30px;border-left: 1px solid #4a90e2;transition:opacity 3s;
  animation:bounce-in 1s;
}
@keyframes bounce-in{
  0%{transform:scale(0);}
  100%{transform:scale(1);}
}
.recruit-border{margin-bottom: 16px;border:1px solid #4A90E2}
.recruit-div-p{margin: 0;font-size: 16px;line-height: 40px;}
.recruit-table{width: 100%;}
.recruit-table .tdBackground {background: url("../../assets/images/about/xuanzhong.png")no-repeat;background-size: 100% 60px;}
.recruitTableTb{width: 25%;height: 60px;text-align: center;}
</style>



// WEBPACK FOOTER //
// src/pages/about/join_us.vue